package cc.easyandroid.easycompose.component.router.children

/**
 * A simple implementation of the [ChildNavState] interface.
 */
data class SimpleChildNavState<out C : Any>(
    override val configuration: C,
    override val status: ChildNavState.Status,
) : ChildNavState<C>
